// H14 (Ticket 4b-2): alerta grande de transferencia -- lógica PURA (cuándo mostrarla, orden si hay varias).
// `incoming` es el objeto que ya arma PhoneContext (delegate.onInvite): { kind, from, phone, client, invitation }.

// Solo "transferencia" (TRF|) dispara la alerta grande; "incluir" (INC|, unirse a una llamada) sigue con el
// aviso de siempre (más chico, dentro del teléfono) -- no es el caso que pide este ticket.
export function shouldShowTransferAlert(incoming) {
  return !!incoming && incoming.kind === "transferencia";
}

// H14-bis (corrección: Founder/gerente probaron en Chrome con central real -- durante la CONSULTA el destino
// nunca ve `incoming` de SIP.js, solo el aviso chico "En consulta con..." que ya leía esta MISMA consulta por
// GET /transfers/incoming; la alerta grande no se enteraba). `items` es la forma real de esa respuesta:
// {items:[{call_id, client_name, phone, from, state, started_at}, ...]}. Un item cuenta como "me están
// transfiriendo YA" si su `state` sigue siendo de vista previa (consultando/destino_confirmado/entregando/
// incierto -- las mismas que ya filtra el backend) y yo no estoy ya en otra llamada viva (si estuviera en
// llamada, la consulta no es para mí ahora mismo).
export const TRANSFER_PREVIEW_STATES = ["consultando", "destino_confirmado", "entregando", "incierto"];
export function pickTransferPreview(items, live) {
  if (live) return null;
  const queue = pickTransferQueue(items).filter((it) => TRANSFER_PREVIEW_STATES.includes(it.state));
  return queue[0] || null;
}

// Ordena una lista de transferencias entrantes por quién llegó PRIMERO (started_at asc) y nunca duplica el
// mismo call_id. Hoy PhoneContext solo expone UNA (`incoming`) a la vez -- esto queda listo para cuando
// /transfers/incoming entregue varias de verdad al mismo tiempo, sin reordenar ni repetir ninguna.
export function pickTransferQueue(items) {
  const seen = new Set();
  const out = [];
  for (const it of (items || [])) {
    if (!it || !it.call_id || seen.has(it.call_id)) continue;
    seen.add(it.call_id);
    out.push(it);
  }
  return out.sort((a, b) => String(a.started_at || "").localeCompare(String(b.started_at || "")));
}
